import { render, staticRenderFns } from "./TicketConfig.vue?vue&type=template&id=de8b4058&"
import script from "./TicketConfig.vue?vue&type=script&lang=js&"
export * from "./TicketConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports